// extracted by css-extract-rspack-plugin
export default {"cls1":"ArticlesFilters-cls1_xre","cls2":"ArticlesFilters-cls2_CGt ArticlesFilters-cls1_xre"};